import { Analytics } from "./analytics";
import $ from "jquery";

function analyticsCollectorHeroCardsCasino() {
    if (Analytics.vertical != "hry") {
        return;
    }

    const items = $(".hero-card__inner");
    if (!items.length) {
        return;
    }

    items.each((_, element) => {
        const $item = $(element);
        const $itemImage = $item.find("img:visible");
        const position = Analytics.getBannerPosition(element, false);
        const index = $item.parent().data("slide-index");

        Analytics.addPromo(
            $item.data("a-codename"),
            `VerticalList.${Analytics.vertical}.carousel`,
            $itemImage.attr("src") || $itemImage.attr("data-src"),
            `vertical.list.${Analytics.vertical}.${position}.carousel${index ? `.${index}` : ""}`
        );

        element.addEventListener("click", () => {
            Analytics.actionShowPromo(
                $item.data("a-codename"),
                `VerticalList.${Analytics.vertical}.carousel`,
                $itemImage.attr("src") || $itemImage.attr("data-src"),
                `vertical.list.${Analytics.vertical}.${position}.carousel${index ? `.${index}` : ""}`
            );
        });
    });
}

function analyticsCollectorHeroCardsTicket() {
    if (Analytics.vertical !== "losy" && Analytics.vertical !== "elosy") {
        return;
    }

    const items = $(".hero-card__inner");
    if (!items.length) {
        return;
    }

    items.each((_, element) => {
        const $item = $(element);
        const $itemImage = $item.find("img:visible");
        const hasMonthTip = items.find(".product-card__badge-month-tip").length > 0;
        const position = Analytics.getBannerPosition(element, false);
        let index = $item.parent().data("slide-index");
        if (!index) {
            index = 1;
        }

        Analytics.addPromo(
            `${$item.data("a-codename")}${hasMonthTip ? ".tipMesice" : ""}`,
            `VerticalList.${Analytics.vertical}.${position}.carousel`,
            $itemImage.attr("src") || $itemImage.attr("data-src"),
            `vertical.list.${Analytics.vertical}.${position}.carousel.${index}`
        );

        element.addEventListener("click", () => {
            Analytics.actionShowPromo(
                `${$item.data("a-codename")}${hasMonthTip ? ".tipMesice" : ""}`,
                `VerticalList.${Analytics.vertical}.${position}.carousel`,
                $itemImage.attr("src") || $itemImage.attr("data-src"),
                `vertical.list.${Analytics.vertical}.${position}.carousel.${index}`
            );
        });
    });
}

function analyticsCollectorHeroCardsLotteryDetail() {
    // other cases are taken by heroCardsAnalytics
    if (Analytics.vertical !== "loterie" || environment.nodeAliasPath === "/loterie") {
        return;
    }

    const items = $(".hero-card__inner");
    if (!items.length) {
        return;
    }

    items.each((_, element) =>
        Analytics.addPromoHeroCard(
            element,
            "detail.loterie",
            `detail.loterie.${window.environment.game}`,
            "img:visible"
        )
    );

    items.click((e) => {
        Analytics.actionShowPromoHeroCard(
            e.currentTarget,
            "detail.loterie",
            `detail.loterie.${window.environment.game}`,
            "img:visible"
        );
    });
}

function analyticsCollectorHeroCardsGeneral() {
    if (Analytics.vertical) {
        // handled by specific collectors
        return;
    }

    const items = $(".hero-card__inner");
    if (!items.length) {
        return;
    }

    items.each((_, element) => {
        const $item = $(element);
        const $itemImage = $item.find("img:visible");
        const name = $item.find(".hero-card__title").text().trim() || "";

        Analytics.addPromo(
            $item.data("a-codename"),
            name,
            $itemImage.attr("src") || $itemImage.attr("data-src"),
            $item.data("a-position")
        );

        element.addEventListener("click", () => {
            Analytics.actionShowPromo(
                $item.data("a-codename"),
                name,
                $itemImage.attr("src") || $itemImage.attr("data-src"),
                $item.data("a-position")
            );
        });
    });
}

export function analyticsCollectorHeroCards() {
    analyticsCollectorHeroCardsCasino();
    analyticsCollectorHeroCardsLotteryDetail();
    analyticsCollectorHeroCardsTicket();
    analyticsCollectorHeroCardsGeneral();
}
